var _rect, _rect2, _rect3, _path, _g, _g2, _g3, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalheaderimg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 88,
    viewBox: "0 0 51 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 37.5,
    width: 50,
    height: 50,
    rx: 6.5,
    fill: "white",
    stroke: "url(#paint0_linear_5419_6106)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 45.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 45.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#DEE1E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0145 52.8434C24.6244 52.4906 25.3764 52.4906 25.9863 52.8434L33.2903 57.0678C33.8989 57.4197 34.2736 58.0694 34.2736 58.7724V67.2279C34.2736 67.9309 33.8989 68.5806 33.2903 68.9326L25.9863 73.1569C25.3764 73.5097 24.6244 73.5097 24.0145 73.1569L16.7105 68.9326C16.1019 68.5806 15.7272 67.9309 15.7272 67.2279V58.7724C15.7272 58.0694 16.1019 57.4197 16.7105 57.0678L24.0145 52.8434Z",
    fill: "#EDF4FF",
    fillOpacity: 0.1,
    stroke: "url(#paint1_linear_5419_6106)",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5419_6106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5181 63.27C24.8146 63.0921 25.185 63.0921 25.4815 63.27L29.7709 65.8436C30.377 66.2073 30.377 67.0856 29.7709 67.4493L25.4815 70.0229C25.185 70.2008 24.8146 70.2008 24.5181 70.0229L20.2287 67.4493C19.6226 67.0856 19.6226 66.2073 20.2287 65.8436L24.5181 63.27Z",
    fill: "url(#paint2_linear_5419_6106)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6467 63.4843C24.864 63.354 25.1355 63.354 25.3529 63.4843L29.6423 66.058C30.0865 66.3245 30.0865 66.9684 29.6423 67.2349L25.3529 69.8086C25.1355 69.939 24.864 69.939 24.6467 69.8086L20.3573 67.2349C19.9131 66.9684 19.9131 66.3245 20.3573 66.058L24.6467 63.4843Z",
    stroke: "url(#paint3_linear_5419_6106)",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5419_6106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5181 59.6044C24.8146 59.4266 25.185 59.4266 25.4815 59.6044L29.7709 62.1781C30.377 62.5417 30.377 63.4201 29.7709 63.7838L25.4815 66.3574C25.185 66.5353 24.8146 66.5353 24.5181 66.3574L20.2287 63.7838C19.6226 63.4201 19.6226 62.5417 20.2287 62.1781L24.5181 59.6044Z",
    fill: "url(#paint4_linear_5419_6106)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6467 59.8188C24.864 59.6884 25.1355 59.6884 25.3529 59.8188L29.6423 62.3925C30.0865 62.659 30.0865 63.3028 29.6423 63.5694L25.3529 66.143C25.1355 66.2734 24.864 66.2734 24.6467 66.143L20.3573 63.5694C19.9131 63.3028 19.9131 62.659 20.3573 62.3925L24.6467 59.8188Z",
    stroke: "url(#paint5_linear_5419_6106)",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5419_6106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5181 55.9389C24.8146 55.761 25.185 55.761 25.4815 55.9389L29.7709 58.5126C30.377 58.8762 30.377 59.7546 29.7709 60.1182L25.4815 62.6919C25.185 62.8698 24.8146 62.8698 24.5181 62.6919L20.2287 60.1182C19.6226 59.7546 19.6226 58.8762 20.2287 58.5126L24.5181 55.9389Z",
    fill: "url(#paint6_linear_5419_6106)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6467 56.1533C24.864 56.0229 25.1355 56.0229 25.3529 56.1533L29.6423 58.7269C30.0865 58.9935 30.0865 59.6373 29.6423 59.9039L25.3529 62.4775C25.1355 62.6079 24.864 62.6079 24.6467 62.4775L20.3573 59.9039C19.9131 59.6373 19.9131 58.9935 20.3573 58.7269L24.6467 56.1533Z",
    stroke: "url(#paint7_linear_5419_6106)",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.5,
    y1: 37,
    x2: 24.5,
    y2: -4.14528e-8,
    stroke: "url(#paint8_linear_5419_6106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5419_6106",
    x: 19.503,
    y: 63.109,
    width: 10.9921,
    height: 7.56048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.242733
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.135237
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_6106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_6106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5419_6106",
    x: 19.503,
    y: 59.4435,
    width: 10.9921,
    height: 7.56048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.242733
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.135237
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_6106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_6106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5419_6106",
    x: 19.503,
    y: 55.7779,
    width: 10.9921,
    height: 7.56048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.242733
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.135237
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_6106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_6106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5419_6106",
    x1: 0.732759,
    y1: 78.5881,
    x2: 51,
    y2: 78.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5419_6106",
    x1: 14.3199,
    y1: 69.9501,
    x2: 35.9969,
    y2: 69.9501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5419_6106",
    x1: 24.9998,
    y1: 62.981,
    x2: 24.9998,
    y2: 70.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5419_6106",
    x1: 19.0662,
    y1: 68.959,
    x2: 31.109,
    y2: 68.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5419_6106",
    x1: 24.9998,
    y1: 59.3154,
    x2: 24.9998,
    y2: 66.6464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5419_6106",
    x1: 19.0662,
    y1: 65.2935,
    x2: 31.109,
    y2: 65.2935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5419_6106",
    x1: 24.9998,
    y1: 55.6499,
    x2: 24.9998,
    y2: 62.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5419_6106",
    x1: 19.0662,
    y1: 61.628,
    x2: 31.109,
    y2: 61.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5419_6106",
    x1: 25.8155,
    y1: 36.4684,
    x2: 25.8155,
    y2: 3.73071e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalheaderimg3);
export default __webpack_public_path__ + "static/media/modalheaderimg3.c1d19fff56c1af50f567d7d71b8792a0.svg";
export { ForwardRef as ReactComponent };